<template lang="html">
  <div>
    <!-- <div class="" :style="{'z-index': '1', 'position': 'fixed', 'background': 'white', 'margin-left': '20px', 'width': '100%'}"> -->
    <div class="">
      <div class='ddContainer row'>
        <div class='ddHeaders grid-1'>STORES:</div>
        <div class="margin-reset padding-reset grid-3">
          <dropdown
          :id='400'
          :list='storeLevels'
          :defaultText='selectedStoreLevelValue'
          v-model='selectedStoreLevelValue'
          :selectedItem='(gettersAggInputData.storeLevel) ? gettersAggInputData.storeLevel.name : ""'/>
        </div>
        <span class='notification' v-if="pastOrPendingFlag === 'PAST'">
          Estimated figures are marked with
          <span class='primary-green-text'>Green</span>
          and Actual figures are marked with
          <span class='black-text'>Black</span>.
        </span>
        <div class="">
          <span :style="{'font-size': '1.3rem'}">Offer Name: </span>
          <span :style="{'padding-left': '0.5rem', 'font-size': '1.2rem', 'color': '#026937'}">{{gettersAggInputData.offers.name}}</span>
          <span :style="{'padding-left': '0.5rem', 'font-size': '1.3rem'}">Campaign Period: </span>
          <span :style="{'padding-left': '0.5rem', 'font-size': '1.2rem', 'color': '#026937'}">{{gettersAggInputData.period.name}}</span>
        </div>
      </div>
      <div @scroll='topScrollContainer'
        id='selectedOfferscrollWrapper'
        class="scrollWrapper"
        :style="{'margin-left': `${marginLeft}px`, 'width': `${scrollableWidth}px`, 'min-width': `${tableContainerWidth}px`}">
      <div class='simulateScrollDiv' :style='{width:  `${scrollableChildrenWidth * offersListData.length}rem`}'/>
    </div>
    </div>
    <div class="outer-div-min" id="outer-div-min">
      <div class="inner-div" id='selectedOffersInnerDiv'>
        <div v-if='hasDataToShow'>
          <div class="inline-block margin-fix" id='selectedOffersHeaderContainer'>
            <data-table :data='offersListHeaders' :styles='tableStyles.offersListHeaderStyles'></data-table>
          </div>
          <div @scroll="bottomScrollContainer"
            id='offersListScrollableX'
            class="scrollable-x inline-block margin-fix"
            :style='{width: `${scrollableWidth}px`}'>
            <div
              class="table-container"
              :style='{width:  `${scrollableChildrenWidth * offersListData.length - (Math.floor(Number((offersListData.length.toString()).replace(/.$/,"0")) / 2))}rem`}'
            >
              <div
              class="inline-block margin-fix"
              :class="{'myOfferStyle': data.my_offer, otherOfferStyle: !data.my_offer}"
              v-for='data in offersListData'
              :style="{width: `${scrollableChildrenWidth}rem`}"
              >
                <data-table
                  :type='type'
                  :handleEvent='childEvent'
                  :data='data'
                  :styles='tableStyles.offersListDataStyle'
                  :stringPadding='offerNameStringPadding'
                />
              </div>
            </div>
        </div>
        </div>
        <div v-else class='notDataPreview'>
          <h2 class='grey-text'>{{ noDataFoundText }}</h2>
          <button
            type="button"
            :class="{'width_3': true, 'primary-green-bg': true}"
            @click="goBack">
            Back
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { values, cloneDeep } from 'lodash'
import DataTable from 'src/components/shared/flexTables/DataTable'
import { tableStyles } from './tableStyles'
import { mapActions, mapGetters } from 'vuex'
import * as NameSpace from 'src/store/NameSpace'
import Dropdown from 'src/components/shared/Dropdown'
import { TableHeightByFixedWidth } from 'src/Services/tableLayoutHelper/height'

export default {
  data () {
    return {
      pastOrPendingFlag: 'PENDING',
      selectedStoreLevelValue: null,
      tableStyles: tableStyles,
      scrollableWidth: '0px',
      scrollableChildrenWidth: 15,
      type: 'record',
      nextRouterPath: '/pending-offers/offer-select',
      previousRouterPath: '/pending-offers',
      nextPastRouterPath: '/past-offers/offer-select',
      previousPastRouterPath: '/past-offers',
      hasDataToShow: true,
      noDataFoundText: 'No Data Found, Please try some other offer.',
      marginLeft: 0,
      tableContainerWidth: 0,
      offerNameStringPadding: {
        length: 15
      }
    }
  },
  watch: {
    offersListData () {
      if (Object.keys(this.table.data).length) {
        this.hasDataToShow = true
      } else {
        this.hasDataToShow = false
      }
    },
    selectedStoreLevelValue () {
      if (this.selectedStoreLevelValue &&
        this.selectedStoreLevelValue &&
        this.selectedStoreLevelValue.id !== this.gettersAggInputData.storeLevel.id
      ) {
        let clonedObject = cloneDeep(this.gettersAggInputData)
        clonedObject.storeLevel = this.selectedStoreLevelValue
        this.setAggInputData(clonedObject)
        if (this.pastOrPendingFlag === 'PAST') {
          this.fetchSelectedPendingOffer({ itemToOfferMapping: this.gettersAggCellData.object, storeLevel: this.selectedStoreLevelValue.id, actual_calc: true })
        } else {
          this.fetchSelectedPendingOffer({ itemToOfferMapping: this.gettersAggCellData.object, storeLevel: this.selectedStoreLevelValue.id })
        }
      }
    }
  },
  mounted () {
    this.pageSetup()
    window.addEventListener('resize', () => {
      this.pageSetup()
    })
  },
  beforeUpdate () {
    this.$nextTick(() => {
      this.pageSetup()
    })
  },
  computed: {
    ...mapGetters({
      table: NameSpace.GET_SELECTED_PENDING_APPROVALS,
      gettersLandingInfo: NameSpace.GET_LANDING_DATA,
      gettersAggCellData: NameSpace.GET_SELECTED_AGG_DATA,
      gettersAggInputData: NameSpace.GET_AGG_INPUT_FILTER_DATA
    }),
    offersListHeaders () {
      return this.table.headers
    },
    offersListData () {
      if (Object.keys(this.table.data).length) {
        let orginalData = this.table.data
        if (this.pastOrPendingFlag === 'PAST') {
          let array = []
          let data
          for (let i = 0; i < orginalData.length; i++) {
            data = cloneDeep(orginalData[i])
            if (i > 0 && i % 2 !== 0) {
              data[0].type = 'past'
            }
            // array.push(orginalData[i])
            data.lock = orginalData[i].lock
            data.my_offer = orginalData[i].my_offer
            array.push(data)
          }
          return array
        } else {
          return orginalData
        }
      } else {
        return []
      }
    },
    data () {
      return this.gettersLandingInfo.data
    },
    storeLevels () {
      if (this.data) {
        return this.data.storeLevel
      }
    }
  },
  beforeDestroy () {
    this.resetSelectedPendingOffer()
  },
  created () {
    if (this.$route.name === 'selectedPastOffers') this.pastOrPendingFlag = 'PAST'
    else this.pastOrPendingFlag = 'PENDING'

    let storeData = this.gettersAggInputData.storeLevel

    if (storeData && storeData.id) {
      if (this.pastOrPendingFlag === 'PAST') {
        this.fetchSelectedPendingOffer({ itemToOfferMapping: this.gettersAggCellData.object, storeLevel: storeData.id, actual_calc: true })
      } else {
        this.fetchSelectedPendingOffer({ itemToOfferMapping: this.gettersAggCellData.object, storeLevel: storeData.id })
      }
    } else {
      if (this.pastOrPendingFlag === 'PAST') {
        this.$router.push(this.previousPastRouterPath)
      } else {
        this.$router.push(this.previousRouterPath)
      }
    }
  },
  methods: {
    ...mapActions({
      fetchSelectedPendingOffer: NameSpace.ACTION_SELECTED_PENDING_APPROVALS,
      setSelectedOffer: NameSpace.ACTION_SELECT_OFFER_NAME,
      setAggInputData: NameSpace.SET_AGG_INPUT_FILTER_DATA,
      resetSelectedPendingOffer: NameSpace.RESET_SELECTED_PENDING_APPROVALS
    }),
    topScrollContainer () {
      let scrollWrapper = document.getElementById('selectedOfferscrollWrapper')
      let actualWrapper = document.getElementById('offersListScrollableX')
      actualWrapper.scrollLeft = scrollWrapper.scrollLeft
    },
    bottomScrollContainer () {
      let actualWrapper = document.getElementById('selectedOfferscrollWrapper')
      let scrollWrapper = document.getElementById('offersListScrollableX')
      actualWrapper.scrollLeft = scrollWrapper.scrollLeft
    },
    getMarginLeft () {
      let headerTable = document
        .getElementById('selectedOffersHeaderContainer')
        .getBoundingClientRect()
      let scrollWrapper = document.getElementById('outer-div-min')
      this.tableContainerWidth = scrollWrapper.clientWidth - (headerTable.width + headerTable.left + 20)
      // this.tableContainerWidth = scrollWrapper.clientWidth + headerTable.width + headerTable.left
      return headerTable.width + headerTable.left
    },
    getTableDataFrom (offersListData) {
      return offersListData.map(offer => {
        return values(offer)
      })
    },
    pageSetup () {
      let selectedOffersHeaderContainer = document.querySelector('#selectedOffersHeaderContainer')
      let dataContainer = document.querySelector('#offersListScrollableX .table-container .inline-block.margin-fix')
      if (selectedOffersHeaderContainer && dataContainer && this.hasDataToShow) {
        this.scrollableWidth = this.getScrollableWidth()
        this.marginLeft = this.getMarginLeft()
        this.modifyTableHeightByData('#selectedOffersHeaderContainer')
        this.modifyTableHeightByData('#offersListScrollableX .table-container .inline-block.margin-fix')
        //  let moveAbleEl = document.getElementById('selectedOffersHeaderContainer')
        //  let scrollableX = document.getElementById('offersListScrollableX')
        //  this.balanceTableHeight(scrollableX, this.scrollableWidth, moveAbleEl)
      }
    },
    modifyTableHeightByData (el) {
      let tableHeightAdjustment = new TableHeightByFixedWidth(
        this.offersListData,
        this.scrollableChildrenWidth,
        '1.5rem',
        '1rem'
      )
      if (this.offersListData && this.offersListData.length) tableHeightAdjustment.modifyTableRowHeight(el)
    },
    getOffersListHeaders (offersListSchema) {
      let listHeaders = []
      for (let offer in offersListSchema) {
        listHeaders.push(offersListSchema[offer].name)
      }
      return listHeaders
    },
    getScrollableWidth () {
      if (
        document.getElementById('selectedOffersInnerDiv') &&
        document.getElementById('selectedOffersHeaderContainer')
      ) {
        let selectedOffersInnerDiv = document.getElementById('selectedOffersInnerDiv').clientWidth
        let selectedOffersHeaderContainer = document.getElementById('selectedOffersHeaderContainer').clientWidth
        let paddingOnInnerDiv = 90
        // console.log(selectedOffersInnerDiv, selectedOffersHeaderContainer, paddingOnInnerDiv)
        return selectedOffersInnerDiv - selectedOffersHeaderContainer - paddingOnInnerDiv
      }
    },
    balanceTableHeight (reference, checkElWidth, ...moveAbleEls) {
      // console.log(reference, checkElWidth, moveAbleEls)
      if (this.hasScrollBars(reference, checkElWidth)) {
        moveAbleEls.forEach(el => {
          // console.log(el.childNodes)
          el.childNodes[0].style.top = '-22px'
        })
      }
    },
    hasScrollBars (el, width) {
      return el.scrollWidth > width
    },
    childEvent (record) {
      if (record && record.clickable) {
        this.setSelectedOffer({ name: record.value, id: record.id })
        if (this.pastOrPendingFlag === 'PAST') {
          this.$router.push(this.nextPastRouterPath)
        } else {
          this.$router.push(this.nextRouterPath)
        }
      }
    },
    goBack () {
      this.$router.push(this.previousRouterPath)
    }
  },
  components: {
    DataTable,
    Dropdown
  }
}
</script>

<style lang="css" scoped>
  .scrollWrapper {
    overflow-x: scroll;
    z-index: 1;
    overflow-y: hidden;
  }
  .simulateScrollDiv {
    height: 1rem;
  }
  .myOfferStyle {
    background: white;
  }
  .otherOfferStyle {
    background: rgb(242, 242, 242);
  }
  .notDataPreview {
    text-align: center;
    background: #eee;
    padding: 0.5rem 0;
    margin: 0.5rem 0;
    border-radius: 0.2rem;
    border: 0.1rem solid #ccc;
    font-size: 1.5rem;
  }
  .ddContainer {
    margin-top: 1.5rem;
    margin-left: 1rem;
  }
  .ddHeaders {
    padding: 1rem 0;
    text-decoration: none;
    font-size: 1.2rem;
    color: black;
  }
  .margin-fix {
    margin-left: -.5rem;
  }

  .scrollable-x {
    overflow-x: auto;
  }

  .vertical-top {
    vertical-align: top;
  }
  #selectedOffersInnerDiv > * {
    position: relative;
  }
  #selectedOffersHeaderContainer {
    vertical-align: top;
  }
  .inline-block {
    display: inline-block;
  }
  .grid-12.padding-reset {
    padding: 0;
  }
  .grid-12.margin-reset {
    margin: 0;
  }
  .notification {
    color: #777;
    vertical-align: sub;
    font-size: 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// SelectedOffersList.vue?2ecce49e